import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useYokohamaData } from "../../../lib/useMockData";

export default function PlansSection() {
  const { plansData } = useYokohamaData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-3">{plansData.label}</p>
              <h2 className="section-title">{plansData.title}</h2>
              <p className="section-subtitle max-w-3xl mx-auto">{plansData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plansData.plans.map((plan, idx) => (
              <ScrollReveal key={plan.name} direction="up" delay={idx * 120}>
                <div className="card-luxury bg-white border border-airdoa-gray-light/50 h-full flex flex-col">
                  <div className="aspect-[3/2] overflow-hidden relative">
                    <img
                      src={plan.image}
                      alt={plan.name}
                      className="w-full h-full object-cover object-top"
                    />
                    {plan.popular && (
                      <div className="absolute top-3 right-3 px-3 py-1 bg-airdoa-gold text-airdoa-navy text-xs font-medium rounded">
                        人気No.1
                      </div>
                    )}
                  </div>
                  <div className="p-5 md:p-6 flex-1 flex flex-col">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="text-lg font-serif font-semibold text-airdoa-navy">{plan.name}</h3>
                      <span className="text-xs text-airdoa-gray">{plan.duration}</span>
                    </div>
                    <p className="text-xs text-airdoa-gray mb-3">{plan.route}</p>
                    <p className="text-sm text-airdoa-gray mb-4">{plan.description}</p>
                    <p className="text-lg font-serif font-semibold text-airdoa-navy">{plan.price}</p>
                    <p className="text-xs text-airdoa-gray mb-4">{plan.priceNote}</p>
                    <ul className="flex flex-col gap-1.5">
                      {plan.features.map((f) => (
                        <li key={f} className="flex items-center gap-2 text-sm text-airdoa-gray">
                          <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold">
                            <i className="ri-check-line" />
                          </span>
                          {f}
                        </li>
                      ))}
                    </ul>
                    <Link to="/pricing" className="btn-primary mt-auto w-full text-center text-sm py-3">
                      詳細を見る
                    </Link>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
